module.exports = __webpack_public_path__ + "img/album23_14.45a9b50e.jpg";